module.exports = __webpack_public_path__ + "static/img/img5.b0813822.png";